import * as actionTypes from '../actionTypes';

//! Podcast
export const getPodcast = payload => ({
    type: actionTypes.GET_PODCAST, payload
});

export const setPodcast = payload => ({
    type: actionTypes.SET_PODCAST, payload
});

export const createPodcast = payload => ({
    type: actionTypes.CREATE_PODCAST, payload
});

export const updatePodcast = payload => ({
    type: actionTypes.UPDATE_PODCAST, payload
});

export const deletePodcast = payload => ({
    type: actionTypes.DELETE_PODCAST, payload
});

export const changePodcastStatus = payload => ({
    type: actionTypes.CHANGE_PODCAST_STATUS, payload
});

//! Videoclip
export const getVideoclip = payload => ({
    type: actionTypes.GET_VIDEOCLIP, payload
});

export const setVideoclip = payload => ({
    type: actionTypes.SET_VIDEOCLIP, payload
});

export const createVideoclip = payload => ({
    type: actionTypes.CREATE_VIDEOCLIP, payload
});

export const updateVideoclip = payload => ({
    type: actionTypes.UPDATE_VIDEOCLIP, payload
});

export const deleteVideoclip = payload => ({
    type: actionTypes.DELETE_VIDEOCLIP, payload
});

export const changeVideoclipStatus = payload => ({
    type: actionTypes.CHANGE_VIDEOCLIP_STATUS, payload
});

//! News
export const getNews = payload => ({
    type: actionTypes.GET_NEWS, payload
});

export const setNews = payload => ({
    type: actionTypes.SET_NEWS, payload
});

export const createNews = payload => ({
    type: actionTypes.CREATE_NEWS, payload
});

export const updateNews = payload => ({
    type: actionTypes.UPDATE_NEWS, payload
});

export const deleteNews = payload => ({
    type: actionTypes.DELETE_NEWS, payload
});

export const changeNewsStatus = payload => ({
    type: actionTypes.CHANGE_NEWS_STATUS, payload
});

//! Live
export const getLive = payload => ({
    type: actionTypes?.GET_LIVE, payload
});

export const setLive = payload => ({
    type: actionTypes?.SET_LIVE, payload
});

export const createLive = payload => ({
    type: actionTypes?.CREATE_LIVE, payload
});

export const updateLive = payload => ({
    type: actionTypes?.UPDATE_LIVE, payload
});

export const deleteLive = payload => ({
    type: actionTypes?.DELETE_LIVE, payload
});

export const changeLiveStatus = payload => ({
    type: actionTypes?.CHANGE_LIVE_STATUS, payload
});